var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1551.2 1185.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#114d6e;}.cls-2{fill:#1d1d1b;}.cls-3{fill:#2094d2;}.cls-4{fill:#1c82b8;}.cls-5{fill:#1975a6;}.cls-6{fill:#fff;}.cls-7{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:7px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xEB\\xCE\\xD3\\xC8_1",
    "data-name": "\\xEB\\xCE\\xD3\\xC8 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1116.09,
    y: 1069.66,
    width: 30.84,
    height: 94.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1115.97,
    y: 1069.78,
    width: 30.96,
    height: 10.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1134.55,
    y: 1069.66,
    width: 12.38,
    height: 94.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 750.54,
    width: 50.6,
    height: 1174.78
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1285.44 202.26 1109.69 323.39 1108.49 324.21 361.44 324.21 361.44 80.29 1108.49 80.29 1206.05 147.53 1285.44 202.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "423.95 623.87 1171 623.87 1171 379.94 423.95 379.94 247 501.91 423.95 623.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M999.21,379.73S913.81,607.57,371,587.39L424,623.87H1171V379.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1171,405.91s-61.28,208.26-289.79,216.6L1171,623.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1140.57,410.37V593.44H433.42L300.61,501.91l132.81-91.54h707.15m10-10H430.31L283,501.91,430.31,603.44h720.26V400.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1031.36,80.29s-127.13,229-669.92,208.87v35.06h747.05l177-122-177-122Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1285.44,202.26,1109.69,323.39l-176-.53c163.4-6,241.29-114.17,272.4-175.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1099,110.72l132.8,91.53L1099,293.79H391.87V110.72H1099m3.11-10H381.87V303.79h720.26l147.32-101.54L1102.13,100.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 750.54,
    y: 324.22,
    width: 50.6,
    height: 21.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 750.54,
    y: 623.66,
    width: 50.6,
    height: 21.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 781.43,
    y: 623.66,
    width: 19.71,
    height: 551.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M727.18,516.33a22.48,22.48,0,0,0-9.09-1.55h-2.38V460.25c0-8.7-3.88-13.1-11.53-13.1a8.75,8.75,0,0,0-6.21,2.43,57.42,57.42,0,0,0-6.18,7.33L654,507.49q-1.58,2.07-2.64,3.49c-.72,1-1.43,2-2.09,3a14.42,14.42,0,0,0-1.57,3.07,8.78,8.78,0,0,0-.54,3,11.38,11.38,0,0,0,3.61,8.85c2.38,2.16,6,3.25,10.63,3.25H696.5v12.58c0,3.73.89,6.6,2.64,8.56a9.78,9.78,0,0,0,14,.07c1.73-1.91,2.6-4.81,2.6-8.63V532.13h3.67c3.74,0,6.6-.68,8.52-2s3-3.6,3-6.59C730.91,519.87,729.65,517.45,727.18,516.33ZM696.5,476.1v38.68H667.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M800.16,457.3a31.27,31.27,0,0,0-10.76-7.14,36.53,36.53,0,0,0-13.59-2.44c-7.53,0-14.1,1.85-19.54,5.5a34.34,34.34,0,0,0-12.49,16,64.85,64.85,0,0,0-3.61,15A150.47,150.47,0,0,0,739,503.69a110.35,110.35,0,0,0,1,15.62,64,64,0,0,0,3.29,13.24,38.19,38.19,0,0,0,13.19,17.29,34.8,34.8,0,0,0,37.31,1.6,35.89,35.89,0,0,0,12.8-13.24A47.56,47.56,0,0,0,812,522.71a123.83,123.83,0,0,0,1.44-20.23c0-14.4-1.85-25.7-5.49-33.61A40.92,40.92,0,0,0,800.16,457.3Zm-38.59,66.17A126.05,126.05,0,0,1,760,501.62c0-13,1.22-22.78,3.63-29s6.43-9.05,12.45-9.05c4.15,0,7.43,1.35,9.76,4s4.1,6.84,5.12,12.23a119.18,119.18,0,0,1,1.56,21.24A133.67,133.67,0,0,1,791,523.19c-1,5.52-2.68,9.8-5.07,12.74s-5.54,4.31-9.74,4.31a11.72,11.72,0,0,1-9.53-4.14C764.31,533.28,762.59,529,761.57,523.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M900.82,516.33a22.52,22.52,0,0,0-9.09-1.55h-2.38V460.25c0-8.7-3.88-13.1-11.53-13.1a8.73,8.73,0,0,0-6.21,2.43,57.42,57.42,0,0,0-6.18,7.33l-37.81,50.58Q826,509.56,825,511c-.72,1-1.43,2-2.1,3a14.83,14.83,0,0,0-1.56,3.07,8.78,8.78,0,0,0-.54,3,11.38,11.38,0,0,0,3.61,8.85c2.38,2.16,6,3.25,10.63,3.25h35.12v12.58c0,3.73.89,6.6,2.64,8.56a9.78,9.78,0,0,0,14,.07c1.72-1.91,2.6-4.81,2.6-8.63V532.13H893c3.75,0,6.61-.68,8.53-2s3-3.6,3-6.59C904.55,519.87,903.29,517.45,900.82,516.33ZM870.14,476.1v38.68H841.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M624.43,177.8h-37.2v20h34.25q3.78,0,5.65,1.69A5.8,5.8,0,0,1,629,204a6,6,0,0,1-1.83,4.53q-1.85,1.75-5.68,1.75H587.23v23.19h38.48q3.88,0,5.87,1.81a6.22,6.22,0,0,1,2,4.81,6.1,6.1,0,0,1-2,4.7q-2,1.8-5.87,1.8H580.84c-3.6,0-6.18-.79-7.76-2.39s-2.36-4.17-2.36-7.73V175.19a13.82,13.82,0,0,1,1-5.81,6.57,6.57,0,0,1,3.31-3.28,13.84,13.84,0,0,1,5.76-1h43.59q3.95,0,5.87,1.75a5.93,5.93,0,0,1,1.92,4.59,6,6,0,0,1-1.92,4.64Q628.38,177.81,624.43,177.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M668.86,211.72h-5.78v26.19q0,5.18-2.28,7.62a7.77,7.77,0,0,1-5.95,2.44,7.59,7.59,0,0,1-6.12-2.55q-2.18-2.56-2.17-7.51V175.19q0-5.34,2.39-7.73c1.6-1.6,4.17-2.39,7.73-2.39h26.86a83,83,0,0,1,9.51.47,23.81,23.81,0,0,1,7.11,1.92,20.6,20.6,0,0,1,6.79,4.61,20.36,20.36,0,0,1,4.47,7,23.26,23.26,0,0,1,1.53,8.43q0,9.12-5.14,14.56t-15.6,7.73a30.27,30.27,0,0,1,8.4,6.9,69.38,69.38,0,0,1,7.14,9.7,71.81,71.81,0,0,1,4.9,9.29q1.76,4.14,1.75,5.7a5.77,5.77,0,0,1-1,3.19,7.28,7.28,0,0,1-2.81,2.51,8.86,8.86,0,0,1-4.11.91,8,8,0,0,1-4.67-1.3,12.68,12.68,0,0,1-3.26-3.31c-.91-1.34-2.14-3.3-3.69-5.9l-6.62-11a61.08,61.08,0,0,0-6.37-9.24,15.7,15.7,0,0,0-5.7-4.33A19.54,19.54,0,0,0,668.86,211.72Zm9.45-34.25H663.08v22.41h14.79a41.79,41.79,0,0,0,10-1,11.73,11.73,0,0,0,6.19-3.51,10,10,0,0,0,2.15-6.81,10.49,10.49,0,0,0-1.73-6,10.37,10.37,0,0,0-4.78-3.87Q686.82,177.48,678.31,177.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M750.76,211.72H745v26.19q0,5.18-2.28,7.62a7.75,7.75,0,0,1-6,2.44,7.57,7.57,0,0,1-6.11-2.55q-2.17-2.56-2.17-7.51V175.19c0-3.56.79-6.14,2.39-7.73s4.17-2.39,7.73-2.39h26.85a82.75,82.75,0,0,1,9.51.47,23.87,23.87,0,0,1,7.12,1.92,20.46,20.46,0,0,1,6.78,4.61,20.24,20.24,0,0,1,4.48,7,23.26,23.26,0,0,1,1.53,8.43q0,9.12-5.14,14.56t-15.6,7.73a30.09,30.09,0,0,1,8.39,6.9,69.45,69.45,0,0,1,7.15,9.7,71.62,71.62,0,0,1,4.89,9.29q1.76,4.14,1.75,5.7a5.83,5.83,0,0,1-1,3.19,7.35,7.35,0,0,1-2.81,2.51,8.9,8.9,0,0,1-4.12.91,8,8,0,0,1-4.67-1.3,12.64,12.64,0,0,1-3.25-3.31c-.91-1.34-2.14-3.3-3.7-5.9l-6.62-11a61.14,61.14,0,0,0-6.36-9.24,15.7,15.7,0,0,0-5.7-4.33A19.59,19.59,0,0,0,750.76,211.72Zm9.46-34.25H745v22.41h14.79a41.74,41.74,0,0,0,10-1,11.77,11.77,0,0,0,6.2-3.51,10,10,0,0,0,2.14-6.81,10.3,10.3,0,0,0-6.5-9.84Q768.73,177.48,760.22,177.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M846.35,163.68q12.67,0,21.77,5.14a33.34,33.34,0,0,1,13.76,14.63q4.67,9.48,4.67,22.26A54.38,54.38,0,0,1,884,222.9a37.11,37.11,0,0,1-7.67,13.4A33.5,33.5,0,0,1,863.75,245a45.44,45.44,0,0,1-17.07,3,44.92,44.92,0,0,1-17.12-3.08,34.06,34.06,0,0,1-12.63-8.7,37.19,37.19,0,0,1-7.64-13.52,54.33,54.33,0,0,1-2.59-17.07,52.59,52.59,0,0,1,2.7-17.23A37,37,0,0,1,817.21,175a33.66,33.66,0,0,1,12.46-8.42A44.74,44.74,0,0,1,846.35,163.68Zm23.46,41.92a38.2,38.2,0,0,0-2.89-15.51,21.66,21.66,0,0,0-8.26-9.93,22.69,22.69,0,0,0-12.31-3.36,22.34,22.34,0,0,0-9.15,1.86,20.21,20.21,0,0,0-7.23,5.42,26,26,0,0,0-4.78,9.1,41,41,0,0,0-1.75,12.42,42,42,0,0,0,1.75,12.57,25.8,25.8,0,0,0,4.95,9.31,20.84,20.84,0,0,0,7.34,5.54,23.2,23.2,0,0,0,20.74-1.34,21.85,21.85,0,0,0,8.45-9.78Q869.82,215.27,869.81,205.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M922.86,211.72h-5.78v26.19q0,5.18-2.28,7.62a7.77,7.77,0,0,1-5.95,2.44,7.61,7.61,0,0,1-6.12-2.55c-1.44-1.71-2.17-4.21-2.17-7.51V175.19q0-5.34,2.39-7.73c1.6-1.6,4.17-2.39,7.73-2.39h26.86a82.75,82.75,0,0,1,9.51.47,24,24,0,0,1,7.12,1.92,20.66,20.66,0,0,1,6.78,4.61,20.38,20.38,0,0,1,4.48,7,23.26,23.26,0,0,1,1.52,8.43q0,9.12-5.14,14.56t-15.6,7.73a30.27,30.27,0,0,1,8.4,6.9,70.26,70.26,0,0,1,7.15,9.7,72.89,72.89,0,0,1,4.89,9.29q1.76,4.14,1.75,5.7a5.77,5.77,0,0,1-1,3.19,7.21,7.21,0,0,1-2.81,2.51,8.83,8.83,0,0,1-4.11.91,8,8,0,0,1-4.67-1.3,12.49,12.49,0,0,1-3.25-3.31c-.91-1.34-2.14-3.3-3.7-5.9l-6.62-11a60.36,60.36,0,0,0-6.37-9.24,15.7,15.7,0,0,0-5.7-4.33A19.5,19.5,0,0,0,922.86,211.72Zm9.45-34.25H917.08v22.41h14.79a41.79,41.79,0,0,0,10-1,11.81,11.81,0,0,0,6.2-3.51,10.09,10.09,0,0,0,2.14-6.81,10.49,10.49,0,0,0-1.73-6,10.37,10.37,0,0,0-4.78-3.87C941.78,177.88,938,177.47,932.31,177.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 331.9,
    y: 1164.1,
    width: 877.89,
    height: 21.36,
    rx: 10.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 209.4,
    y: 1164.1,
    width: 159.81,
    height: 21.36,
    rx: 10.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 1164.1,
    width: 166.84,
    height: 21.36,
    rx: 10.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1254.05,
    y: 1164.1,
    width: 140.72,
    height: 21.36,
    rx: 10.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1439.12,
    y: 1164.1,
    width: 112.08,
    height: 21.36,
    rx: 10.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1312.04 818.71 1312.04 966.58 1207.48 1071.14 1059.61 1071.14 955.05 966.58 955.05 818.71 1059.61 714.15 1207.48 714.15 1312.04 818.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1312,818.71V966.58l-104.56,104.56H1059.61l-70-70c262.93,38.75,265.66-239.2,265.66-239.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1312,892.65s-50.27,186.64-252.43,178.49h147.87L1312,966.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1294.69 825.9 1294.69 959.4 1200.29 1053.8 1066.8 1053.8 972.4 959.4 972.4 825.9 1066.8 731.5 1200.29 731.5 1294.69 825.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1094.07,904.53a18.19,18.19,0,0,0-7.38-1.27h-1.93V859c0-7-3.15-10.63-9.35-10.63a7.13,7.13,0,0,0-5,2,47.25,47.25,0,0,0-5,6l-30.67,41c-.85,1.12-1.56,2.06-2.14,2.84s-1.16,1.6-1.7,2.43a12,12,0,0,0-1.27,2.49,7.11,7.11,0,0,0-.44,2.41,9.24,9.24,0,0,0,2.93,7.19c1.93,1.74,4.83,2.63,8.62,2.63h28.5v10.21c0,3,.72,5.36,2.14,6.94a7.24,7.24,0,0,0,5.65,2.41,7.34,7.34,0,0,0,5.68-2.35c1.4-1.55,2.11-3.9,2.11-7V917.34h3c3,0,5.37-.55,6.92-1.63a6.09,6.09,0,0,0,2.44-5.35C1097.09,907.39,1096.07,905.43,1094.07,904.53Zm-24.89-32.65v31.38H1046Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1153.27,856.63a25.25,25.25,0,0,0-8.73-5.79,29.49,29.49,0,0,0-11-2,26.44,26.44,0,0,0-26,17.42,53,53,0,0,0-2.93,12.17,123.43,123.43,0,0,0-.93,15.82,89.45,89.45,0,0,0,.85,12.67,51.77,51.77,0,0,0,2.67,10.74,31,31,0,0,0,10.69,14,28.2,28.2,0,0,0,30.27,1.29,29,29,0,0,0,10.39-10.74,38.79,38.79,0,0,0,4.35-12.56,100.72,100.72,0,0,0,1.16-16.42c0-11.67-1.49-20.85-4.45-27.26A33.34,33.34,0,0,0,1153.27,856.63ZM1122,910.32a101.83,101.83,0,0,1-1.27-17.73c0-10.57,1-18.49,3-23.53s5.21-7.34,10.1-7.34a10,10,0,0,1,7.91,3.25c1.93,2.21,3.33,5.55,4.16,9.93a97.19,97.19,0,0,1,1.26,17.23,107.93,107.93,0,0,1-1.21,18c-.79,4.47-2.17,7.95-4.11,10.33a10.62,10.62,0,0,1-15.63.14C1124.19,918.27,1122.79,914.83,1122,910.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1234.94,904.53a18.19,18.19,0,0,0-7.38-1.27h-1.93V859c0-7-3.14-10.63-9.35-10.63a7.13,7.13,0,0,0-5,2,47.25,47.25,0,0,0-5,6l-30.67,41c-.85,1.12-1.56,2.06-2.14,2.84s-1.16,1.6-1.7,2.43a12,12,0,0,0-1.27,2.49,7.11,7.11,0,0,0-.44,2.41,9.27,9.27,0,0,0,2.93,7.19c1.93,1.74,4.83,2.63,8.62,2.63h28.5v10.21c0,3,.72,5.36,2.14,6.94a7.26,7.26,0,0,0,5.65,2.41,7.34,7.34,0,0,0,5.68-2.35c1.4-1.55,2.11-3.9,2.11-7V917.34h3c3,0,5.36-.55,6.91-1.63a6.09,6.09,0,0,0,2.44-5.35C1238,907.39,1236.94,905.43,1234.94,904.53Zm-24.89-32.65v31.38h-23.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "538.19 1138.09 343.44 1138.09 346.99 1125.26 353.9 1100.21 358.1 1085.04 364.27 1062.68 376.19 1019.57 382.36 997.21 425.79 840 455.84 840 471.76 897.62 499.27 997.21 505.45 1019.57 517.36 1062.68 523.54 1085.04 534.65 1125.26 538.19 1138.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M538.19,1138.08H343.44l3.55-12.82,6.92-25c135.7-8,117.85-202.59,117.85-202.59l62.89,227.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 303.6,
    y: 1138.08,
    width: 274.44,
    height: 26.09
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "538.19 1138.09 343.44 1138.09 346.99 1125.26 534.65 1125.26 538.19 1138.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M505.45,1019.57s-4.08,86.07-103,105.76l132.17-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "505.45 1019.57 376.19 1019.57 382.36 997.21 499.27 997.21 505.45 1019.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "523.54 1085.04 358.1 1085.04 364.27 1062.68 517.36 1062.68 523.54 1085.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M514.56,1138.08s-36.38,27.47-171.12,26.1H578v-26.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.0884e9ae106851c67e31fffccbf67437.svg";
export { ForwardRef as ReactComponent };